import { Injectable, linkedSignal, Signal, signal } from '@angular/core';
import { Artikel } from '../data/product';

export interface RohstoffbereitstellungQuery {
  vondatum: string | null;
  bisdatum: string | null;
  artikel?: Artikel;
}

export interface RohstoffbereitstellungDetailQuery {
  datum?: string;
  artikel?: Artikel;
}

export abstract class BaseQueryService<T> {
  readonly #query = signal<Signal<T | undefined>>(signal(undefined));

  readonly query = linkedSignal<T | undefined>(() => this.query()());

  registerQuery(query: Signal<T | undefined>): void {
    this.#query.set(query);
  }

  unregisterQuery(query: T | undefined): void {
    this.#query.set(signal(undefined));
  }

  setQuery(query: T | undefined): void {
    this.query.set(query);
  }
}

@Injectable()
export class QueryService extends BaseQueryService<RohstoffbereitstellungQuery> {}

@Injectable()
export class QueryDetailService extends BaseQueryService<RohstoffbereitstellungDetailQuery> {}
